export function getAuthLogoutUrl() {
  const idtoken = localStorage.getItem('idToken');
  const clientid = localStorage.getItem('clientId');

  // El origin en runtime y no una env var: CRA hornea las REACT_APP_* en build time, así que un
  // mismo bundle servido desde una preview de Pages o desde localhost devolvía el logout al host
  // de staging. Keycloak acepta cualquiera de los tres por los wildcards del client.
  return `${process.env.REACT_APP_KEYCLOAK_URL}/realms/happify/protocol/openid-connect/logout?&post_logout_redirect_uri=${window.location.origin}&id_token_hint=${idtoken}&client_id=${clientid}`;
}
